"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CalendarIntegrationSettingsSchema () {
        return CalendarIntegrationSettingsSchema;
    },
    get CalendarIntegrationSettingsSchemaWithDefault () {
        return CalendarIntegrationSettingsSchemaWithDefault;
    },
    get MeetingsIntegrationsSettingsSchema () {
        return MeetingsIntegrationsSettingsSchema;
    },
    get VIDEO_CONFERENCING_PROVIDERS () {
        return _models.VIDEO_CONFERENCING_PROVIDERS;
    },
    get VIDEO_CONFERENCING_PROVIDER_DISPLAY_NAMES () {
        return _models.VIDEO_CONFERENCING_PROVIDER_DISPLAY_NAMES;
    },
    get VideoConferencingConnectionSchema () {
        return VideoConferencingConnectionSchema;
    },
    get VideoConferencingProviderEnum () {
        return VideoConferencingProviderEnum;
    },
    get VideoConferencingSettingsSchema () {
        return VideoConferencingSettingsSchema;
    },
    get VideoConferencingSettingsSchemaWithDefault () {
        return VideoConferencingSettingsSchemaWithDefault;
    },
    get ZoomUserSettingsSchema () {
        return ZoomUserSettingsSchema;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const CalendarIntegrationSettingsSchema = _zod.z.object({
    enabled: _zod.z.boolean()
});
const CalendarIntegrationSettingsSchemaWithDefault = _zod.z.object({
    enabled: _zod.z.boolean().default(false)
});
const VideoConferencingSettingsSchema = _zod.z.object({
    enabled: _zod.z.boolean()
});
const VideoConferencingSettingsSchemaWithDefault = _zod.z.object({
    enabled: _zod.z.boolean().default(false)
});
const VideoConferencingProviderEnum = _zod.z.enum(_models.VIDEO_CONFERENCING_PROVIDERS);
const ZoomUserSettingsSchema = _zod.z.object({
    cloudRecording: _zod.z.boolean(),
    recordingAudioTranscript: _zod.z.boolean(),
    licensed: _zod.z.boolean()
});
const VideoConferencingConnectionBase = _zod.z.object({
    connectedAt: _zod.z.date(),
    accountEmail: _zod.z.string().nullable(),
    tokenExpired: _zod.z.boolean()
});
const VideoConferencingConnectionSchema = _zod.z.discriminatedUnion("provider", [
    VideoConferencingConnectionBase.extend({
        provider: _zod.z.literal("zoom"),
        userSettings: ZoomUserSettingsSchema.nullable()
    }),
    VideoConferencingConnectionBase.extend({
        provider: _zod.z.literal("teams")
    })
]);
const MeetingsIntegrationsSettingsSchema = _zod.z.object({
    calendar: CalendarIntegrationSettingsSchema.optional(),
    video_conferencing: VideoConferencingSettingsSchema.optional()
});
